var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareEvaluation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 59,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#353C3C",
  strokeWidth: 1.7,
  d: "M6.7 57.959a5.49 5.49 0 0 1-4.023-1.673A5.48 5.48 0 0 1 1 52.263V6.7a5.48 5.48 0 0 1 1.673-4.023A5.49 5.49 0 0 1 6.7 1h22.784l17.088 17.088v8.544a11.3 11.3 0 0 0-3.062 1.139 11.7 11.7 0 0 0-2.634 1.993L23.788 46.78v11.178z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "share-evaluation_svg__a",
  width: 19,
  height: 19,
  x: 28,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M46.424 1H28v18.192h18.424z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#share-evaluation_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#353C3C",
  strokeLinecap: "round",
  strokeWidth: 1.7,
  d: "M46.424 18.342H28.85V1"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#621726",
  strokeWidth: 1.7,
  d: "M28.479 57.958V49.2l15.735-15.664c.4-.41.887-.726 1.424-.926a4.6 4.6 0 0 1 1.566-.285 4.3 4.3 0 0 1 1.638.32 4.3 4.3 0 0 1 1.424.961L52.9 36.24c.376.42.677.902.89 1.424.208.496.317 1.028.32 1.566a4.9 4.9 0 0 1-.285 1.6c-.193.551-.51 1.05-.926 1.46L37.235 57.951zM47.2 42.01l2.634-2.777L47.2 36.6l-2.706 2.706z"
})));
export { SvgShareEvaluation as ReactComponent };
export default __webpack_public_path__ + "90806bfa3f3f4f457dfd7c9557e1fc41.svg";